
import React from "react";
import { Loader } from "../../../Common/Loader";
import { FlexColumn, SushiModal } from "../../../Common/styles.common";
import ViewPDF from "../../../../../utils/ViewPDF";
import Breadcrumb from "components/shared/Breadcrumb/Breadcrumb";
import {
    DesktopPage,
    TitleRow as TopRow,
    TitleBlock,
    Title,
    Actions,
    ActionButton,
} from "components/core/Common/DesktopHelpers/DesktopHelpers";
import DownloadIcon from "sushiweb/Icons/all/Download";
import Cross from "sushiweb/Icons/all/Cross";
import ShowToast from "../../../Common/Toast";

// ─── Inline styles ────────────────────────────────────────────────────────────

const previewBodyStyle = {
    background: "#ffffff",
    borderRadius: 12,
    padding: 24,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    overflow: "auto",
    maxHeight: "75vh",
    width: "100%",
};

// ─── Component ────────────────────────────────────────────────────────────────

export default function PreviewInvoiceDesktop({
    poId,
    purchaseOrderNumber,
    itemsLength,
    tonnage,
    pdfBlob,
    setPdfBlob,
    invoiceDetails,
    setShowFile,
    formData,
    po,
    // state / handlers (lifted from the container)
    showLoader,
    openConfirmation,
    closeConfirmation,
    handleConfirmClick,
    showErrorDataModal,
    updatePurchaseOrderErrorModalData,
    closeErrorModal,
    showToast,
    markBuyerOrderCompletedLinkedToDDPurchaseOrderError,
    updatePurchaseOrderError,
    downloadDeliveryInvoices,
    goToDDList,
}) {
    if (showLoader) {
        return <Loader />;
    }

    return (
        <DesktopPage>
            {/* ── Success confirmation modal ── */}
            <SushiModal visible={openConfirmation} isCentered>
                <FlexColumn className="align-items-center p-5">
                    <div className="align-self-end" onClick={closeConfirmation} style={{ cursor: "pointer" }}>
                        <Cross />
                    </div>
                    <img src="/logos/tick_logo.svg" height="80px" width="80px" alt="success" />
                    <span className="fs-22 fw-700 my-4">Invoice uploaded</span>
                    {po?.dd_order_details?.buyer_order_invoice?.length > 0 ||
                    po?.dd_order_details?.delivery_challan?.length > 0 ? (
                        <div
                            onClick={() =>
                                downloadDeliveryInvoices(
                                    po.dd_order_details?.buyer_order_invoice,
                                    po.dd_order_details?.delivery_challan,
                                    po.ref_order_number
                                )
                            }
                        >
                            <ActionButton $primary className="d-flex align-items-center justify-content-between">
                                <DownloadIcon />
                                <span className="ml-2 fs-14 fw-500">Download delivery docs</span>
                            </ActionButton>
                        </div>
                    ) : (
                        <span
                            className="fs-14 fw-500 text-red-500"
                            style={{ cursor: "pointer" }}
                            onClick={closeConfirmation}
                        >
                            Okay
                        </span>
                    )}
                </FlexColumn>
            </SushiModal>

            {/* ── Error modal ── */}
            <SushiModal
                visible={
                    showErrorDataModal &&
                    updatePurchaseOrderErrorModalData &&
                    updatePurchaseOrderErrorModalData.title &&
                    updatePurchaseOrderErrorModalData.title.length > 0
                }
                isCentered
            >
                <FlexColumn className="align-items-center p-5">
                    <div />
                    <img src="/logos/cross-circle-fill.svg" height="80px" width="80px" alt="error" />
                    <div className="text-align-center my-4">
                        <span className="fs-22 fw-700 my-4">
                            {updatePurchaseOrderErrorModalData && updatePurchaseOrderErrorModalData.title}
                        </span>
                    </div>
                    {updatePurchaseOrderErrorModalData &&
                    updatePurchaseOrderErrorModalData.subtitle &&
                    updatePurchaseOrderErrorModalData.subtitle.length > 0 ? (
                        <div className="text-align-center my-4 subtitle-background">
                            <span className="fs-13 fw-700 my-4 text-gray-cool">
                                {updatePurchaseOrderErrorModalData.subtitle}
                            </span>
                        </div>
                    ) : (
                        <></>
                    )}
                    <span
                        className="fs-14 fw-500 text-red-500 mt-4"
                        style={{ cursor: "pointer" }}
                        onClick={() => closeErrorModal()}
                    >
                        Okay
                    </span>
                </FlexColumn>
            </SushiModal>

            {/* ── Toast ── */}
            {showToast && !updatePurchaseOrderErrorModalData && (
                <ShowToast
                    errorMsg={markBuyerOrderCompletedLinkedToDDPurchaseOrderError || updatePurchaseOrderError}
                />
            )}

            {/* ── TopRow: breadcrumb + title + action bar ── */}
            <TopRow>
                <TitleBlock>
                    <Breadcrumb
                        items={[
                            { label: "Home" },
                            { label: "Direct Delivery", onClick: goToDDList },
                            { label: purchaseOrderNumber },
                            { label: "Preview Invoice" },
                        ]}
                    />
                    <Title>{purchaseOrderNumber}</Title>
                </TitleBlock>
                <Actions>
                    <ActionButton type="button" $primary onClick={handleConfirmClick}>
                        Click to confirm
                    </ActionButton>
                </Actions>
            </TopRow>

            {/* ── PDF preview ── */}
            <div style={previewBodyStyle}>
                <ViewPDF pdfBlob={pdfBlob} setPdfBlob={setPdfBlob} />
            </div>
        </DesktopPage>
    );
}
